import { getCoordsFromData } from 'dashboard/utils';
import getWeekData from './getWeekData';

const getCAAChartData = (stats: IStats | null, dateRange: IDateRange) => {
  if (!stats) {
    return null;
  }

  const weekData = getWeekData(stats, dateRange);

  return [
    {
      id: 'Abort',
      data: getCoordsFromData(weekData, 'abort'),
    },
    {
      id: 'Success',
      data: getCoordsFromData(weekData, 'success'),
    },
    {
      id: 'Start',
      data: getCoordsFromData(weekData, 'start'),
    },
    {
      id: 'Close',
      data: getCoordsFromData(weekData, 'closeSlider'),
    },
    {
      id: 'Show',
      data: getCoordsFromData(weekData, 'showSlider'),
    },
    {
      id: 'Inspect',
      data: getCoordsFromData(weekData, 'show'),
    },
    {
      id: 'Checkout',
      data: getCoordsFromData(weekData, 'checkout'),
    },
  ];
};

export default getCAAChartData;
